var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"margin-top":"30px"}},[_c('iframe',{attrs:{"src":"http://dev.cloudvp.cn/flow/detail/1bb86dff44727854fd6c285fda60d79f","width":"100%","height":(_setup.height - 120)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }